import React, { useState } from 'react';
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add"
import CreateServerDialog from './CreateServerDialog';

const CreateRoomButton = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const createNewRoomHandler=()=>{
        setIsDialogOpen(true);
    }
    return (
      <>
        <Button 
        onClick={createNewRoomHandler}
        style={{width:"48px",
        height:"48px",
        borderRadius:"16px",
        margin:0,
        padding:0,
        minWidth:"0",
        marginTop:"10px",
        color:"white",
        backgroundColor:"#f97316"}} >
    
            <AddIcon/>
        </Button>
        <CreateServerDialog
          open={isDialogOpen}
          onClose={() => setIsDialogOpen(false)}
        />
      </>
      )
}

export default CreateRoomButton
